import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { ENTITY_TYPE } from "../../constants/phase";
import { getEntityType } from "../../helpers";
import { getEntityConfig } from "../entityConfig/actions";

export const organizationConfigEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.organizationId,
});

const initialState = organizationConfigEntityAdapter.getInitialState({});

export const organizationConfigSlice = createSlice({
  name: "organizationConfig",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEntityConfig.fulfilled, (state, action) => {
      if (getEntityType(action.meta.arg.entityId) === ENTITY_TYPE.ORGANIZATION && action.payload.status) {
        organizationConfigEntityAdapter.upsertOne(state, action.payload.data);
      }
    });
  },
});

export default organizationConfigSlice.reducer;
